'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var PlayerControlsController = (function () {
    function PlayerControlsController($scope, $rootScope) {
        var _this = this;

        _classCallCheck(this, PlayerControlsController);

        this.$scope = $scope;
        this.$rootScope = $rootScope;

        this.$rootScope.$on('player:state', function (event, state) {
            switch (state) {
                case YT.PlayerState.PLAYING:
                case YT.PlayerState.BUFFERING:
                    //hide stop, show play.
                    _this.$scope.playing = true;
                    break;

                default:
                    //show stop, hide play.
                    _this.$scope.playing = false;
                    break;
            }
        });

        $scope.previous = function () {
            _this.notify('previous');
        };

        $scope.toggle = function () {
            if (!_this.$scope.playing) _this.notify('play');else _this.notify('pause');
        };

        $scope.next = function () {
            _this.notify('next');
        };
    }

    _createClass(PlayerControlsController, [{
        key: 'notify',
        value: function notify(eventName) {
            return this.$rootScope.$broadcast('play:' + eventName);
        }
    }]);

    return PlayerControlsController;
})();

exports['default'] = PlayerControlsController;

PlayerControlsController.$inject = ['$scope', '$rootScope'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/markup/player_controls_controller.js
 ** module id = 40
 ** module chunks = 0
 **/